// Usamos el HTTP_LOGIN porque el baseurl que agrega es diferente
import HTTP from '@/config/axios-config-erp'
import HTTP_LOGIN from '@/config/axios-config-login'

const SrvUsers = {
  // WS para la gestión de usuarios y permisos
  getUsers(tira) {
    const payload = {
      tira: tira
    }
    return HTTP.post(`wscomun/portalinformes/listadoUsuarios`, payload).then(response => {
      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  },
  creaUsuarioSP(payload) {
    return HTTP.post(`wscomun/portalinformes/creaUsuarioSP`, payload).then(response => {
      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  },
  getUsersInformes(payload) {
    return HTTP.post(`wscomun/portalinformes/listaUsuarios`, payload).then(response => {
      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  },
  getPermisosResiduos(user) {
    const payload = {
      usuario: user
    }
    return HTTP.post(`/wscomun/portalinformes/getPermisosResiduos`, payload).then(response => {
      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  },
  validateuser(payload, header) {
    return HTTP_LOGIN.post('/wsr/auth/validateuser', payload, { headers: header }).then(response => {
      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  },
  datosUsuarioPortal(payload) {
    console.trace('datosUsuarioPortal', payload);
    return HTTP.post(`/wscomun/portalinformes/datosUsuarioPortal`, payload).then(response => {
      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  },
  datosUsuario(payload) {
    return HTTP.post(`/wscomun/portalinformes/datosUsuario`, payload).then(response => {
      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  },
  listaOpcionesPortal(payload) {
    return HTTP.post(`/wscomun/portalinformes/listaOpcionesPortal`, payload).then(response => {
      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  },
  actualizaUsuario(payload) {
    return HTTP.post(`/wscomun/portalinformes/actualizaUsuario`, payload).then(response => {
      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  },
  listaInformesPortal(payload) {
    return HTTP.post(`/wscomun/portalinformes/listaInformesPortal`, payload).then(response => {
      return response
    }).catch(error => {
      return Promise.reject(error)
    })
  }
}
export default SrvUsers



// WEBPACK FOOTER //
// ./src/services/srv-users.js